/**
* @version GENERATOR_VERSION::20200422
* @DateTime 2020-05-07T09:38:27.826
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	listCCBContract,
	listCCBContractInit,
	listCCBContractByAuthorizations,
	deleteCCBContract,
	syncCCBContract,
	closeCCBContract
	
} from '@api/house/CCBContract';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {	
		// 初始化信息
		CompoundEntitiesDictionary: cloneObj(RespCommonDef.CompoundEntitiesDictionary),
		//查询接口返回的数据
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
	    Entities:cloneObj(RespCommonDef.Entities),
		//查询条件
		AdvanceQuery:cloneObj(RespCommonDef.AdvanceQuery),
	},

	actions: {
		listCCBContract({
			state
		}) {
			return new Promise((resolve, reject) => {
				listCCBContract(state.AdvanceQuery)
					.then(async res => {
						state.Entities = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listCCBContractByAuthorizations({
			state
		}) {
			return new Promise((resolve, reject) => {
				listCCBContractByAuthorizations(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntities =res
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listCCBContractInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				listCCBContractInit(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntitiesDictionary = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteCCBContract({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteCCBContract({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},
		syncCCBContract({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				syncCCBContract({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},
		closeCCBContract({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				closeCCBContract({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

	}
};
